import { getTelemetryClientConfig } from '@ms/yammer-telemetry-store';

import { reportError } from './errors';

export interface ForwardableEvent {
  readonly name: string;
  readonly properties: Record<string, unknown>;
}

export type TelemetrySubscriber = (event: ForwardableEvent) => void;

const subscribers = new Set<TelemetrySubscriber>();

export const subscribeToTelemetryEvents = (callback: TelemetrySubscriber): (() => void) => {
  subscribers.add(callback);

  return () => subscribers.delete(callback);
};

export const forwardEventToCustomDataStore = (event: ForwardableEvent): void => {
  const clientConfig = getTelemetryClientConfig();
  if (clientConfig?.enableReportingToCustomDataStore) {
    subscribers.forEach((cb) => {
      try {
        cb(event);
      } catch (error) {
        reportError({
          error,
          eventProperties: { operationName: event.name },
          sendToConsole: false,
        });
      }
    });
  }
};
